'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = require('preact');

var _preactFela = require('preact-fela');

var _Button = require('../Core/Button');

var _Button2 = _interopRequireDefault(_Button);

var _HamburgerIcon = require('../Icon/HamburgerIcon');

var _HamburgerIcon2 = _interopRequireDefault(_HamburgerIcon);

var _Core = require('../Core');

var _utils = require('../../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var buttonExtend = function buttonExtend(_ref) {
  var mobile = _ref.mobile;
  return _extends({
    height: '100%'
  }, mobile && {
    position: 'absolute',
    top: 0,
    left: 0
  });
};

var text = function text() {
  return {
    marginLeft: '5px',
    textTransform: 'uppercase',
    fontSize: '10px',
    color: '#ffffff',
    fontWeight: 500
  };
};

var Text = (0, _preactFela.createComponent)(text, 'span');

exports.default = function (_ref2) {
  var mobile = _ref2.mobile,
      inScroll = _ref2.inScroll,
      loggedIn = _ref2.loggedIn,
      onOpenMenu = _ref2.onOpenMenu;

  if (!mobile) {
    return null;
  }

  return (0, _preact.h)(
    'div',
    null,
    (0, _preact.h)(
      _Button2.default,
      _extends({ onClick: function onClick() {
          return onOpenMenu('menu');
        }, inScroll: inScroll, mobile: mobile, extend: buttonExtend, 'aria-label': 'Abrir Menu com op\xE7\xF5es adicionais' }, (0, _utils.getAttrsGtm)("abrir", { clicktype: 'menu-lateral' })),
      (0, _preact.h)(_HamburgerIcon2.default, null),
      (loggedIn || !inScroll) && (0, _preact.h)(
        Text,
        null,
        'menu'
      )
    )
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Header/HeaderMenu.js
// module id = 204
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38